import React, { useEffect, useState } from 'react'
import { Box, Container, Grid, Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { Layout } from '../../components'
import { img } from '../../imgs'
import { useReduxSelector } from '../../hooks'
import { NewsVideoModal } from './news-video-modal'

const GalaSlide: React.FC<{ className: any; item: any; indexPhoto: number; listPhoto: any[] }> = ({
  className,
  item,
  indexPhoto = 0,
  listPhoto = [],
}): JSX.Element => {
  const [newsVideoModal, setNewsVideoModal] = useState<boolean>(false)

  const { data: constants } = useReduxSelector((state) => state.constants)

  return (
    <Box>
      <NewsVideoModal
        item={item}
        indexSlide={indexPhoto}
        listPhoto={listPhoto}
        show={newsVideoModal}
        onClose={() => setNewsVideoModal(false)}
        className={className}
      />

      <Box className={className.galaPhotoZoom} onClick={() => setNewsVideoModal(true)}>
        <img id="play-container" src={item.src} alt="" className={className.galaPhoto} />
      </Box>
    </Box>
  )
}

export const GalaPhotoPage: React.FC = (): JSX.Element => {
  const classes = useStyles()

  const [photoGala, setPhotoGala] = useState<any[]>(Array(300))

  const loadGalaPhoto = () => {
    const arr: { id: number; type: string; theme: string; src: string }[] = []
    for (let i = 1; i < 301; i++) {
      arr.push({
        id: i,
        type: 'PHOTO',
        theme: 'GALA',
        src: `https://cup.irb.rest/backend/static/news/gala/${i}.jpg`,
      })
    }
    setPhotoGala(arr)
  }

  useEffect(() => {
    loadGalaPhoto()
  }, [])

  return (
    <Layout>
      <Box className={classes.page}>
        <Container maxWidth="lg" className={classes.container}>
          <Box className={classes.title}>ГАЛА-УЖИН ЛЕГЕНД IRB</Box>
          <Grid container justifyContent={{ xs: 'center', md: 'space-between' }} spacing={3}>
            {photoGala.length > 0 &&
              photoGala.map((i: any, k: number) => {
                return (
                  <Grid item>
                    <GalaSlide className={classes} item={i} indexPhoto={k} listPhoto={photoGala} />
                  </Grid>
                )
              })}
          </Grid>
        </Container>
        <img src={img.footerMedia} alt="" className={classes.mediaBottom} />
      </Box>
    </Layout>
  )
}

const useStyles = makeStyles(({ font, breakpoints: { down }, palette }: Theme) => ({
  page: {
    width: '100%',
    minHeight: 'calc(100vh - 240px)',
    padding: '50px 0 0',
    overflow: 'hidden',
    position: 'relative',
    backgroundColor: '#131313',
    '& .MuiTab-root': {
      padding: '8px 10px',
      minWidth: 140,
      fontSize: 14,
      borderRadius: 2,
      backgroundColor: 'transparent!important',
      color: '#6C6C6C!important',
      "&[aria-selected^='true']": {
        backgroundColor: `${palette.secondary.main}!important`,
      },
      [down('sm')]: {
        padding: '8px 10px',
        minWidth: 90,
        fontSize: 11,
      },
    },
    [down('md')]: {
      minHeight: 'calc(100vh - 280px)',
    },
    [down('sm')]: {
      padding: '40px 0 0',
      minHeight: 'calc(100vh - 200px)',
    },
  },
  container: {
    paddingBottom: '150px!important',
    [down('md')]: {
      padding: '0 10px 80px!important',
    },
  },
  title: {
    fontSize: 48,
    fontWeight: 700,
    color: palette.text.secondary,
    textTransform: 'uppercase',
    cursor: 'pointer',
    transition: '0.3s',
    marginBottom: 50,
    '&:hover': {
      color: palette.text.primary,
    },
    [down('lg')]: {
      fontSize: 44,
    },
    [down('md')]: {
      fontSize: 42,
    },
    [down('sm')]: {
      textAlign: 'center',
      fontSize: 32,
      maxWidth: 350,
      marginBottom: 30,
    },
  },
  boxSliderGala: {
    width: '100%',
    // marginBottom: 65,
    '& .slick-list': {
      width: '92%',
      position: 'relative',
      left: '4%',
    },
    '& .slick-slide': {},
    '& .slick-next:before, .slick-prev:before': {
      content: 'none',
      width: '80px!important',
      height: '80px!important',
      [down('md')]: {
        width: '70px!important',
        height: '70px!important',
      },
    },
    '& .slick-next': {
      top: '55%',
      right: -35,
      width: '80px!important',
      height: '80px!important',
      [down('md')]: {
        width: '70px!important',
        height: '70px!important',
      },
    },
    '& .slick-prev': {
      top: '55%',
      left: -15,
      width: '80px!important',
      height: '80px!important',
      [down('md')]: {
        width: '70px!important',
        height: '70px!important',
      },
    },
    [down('md')]: {
      marginBottom: 55,
    },
    [down('sm')]: {
      marginBottom: 45,
    },
  },
  galaPhotoZoom: {
    width: 265,
    // height: 160,
    borderRadius: 6,
    display: 'flex',
    cursor: 'pointer',
    overflow: 'hidden',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0px auto',
    '-webkit-tap-highlight-color': 'transparent',
    '&:hover': {
      '& #play-container': {
        transform: 'scale(1.03)',
      },
    },
    [down('md')]: {
      width: 280,
      height: 170,
    },
  },
  galaPhoto: {
    width: 265,
    minHeight: 160,
    borderRadius: 6,
    transition: '0.3s',
    [down('md')]: {
      width: 280,
      minHeight: 170,
    },
  },
  imgBoxModal: {
    width: '100%',
    height: 800,
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    borderRadius: 6,
    [down('sm')]: {
      height: 400,
    },
  },
  imgModal: {
    width: '100%',
    borderRadius: 6,
  },
  titleModal: {
    fontSize: 20,
    fontWeight: 700,
    textAlign: 'center',
    paddingLeft: 20,
    paddingRight: 20,
    lineHeight: 1.4,
    textTransform: 'uppercase',
    margin: '20px 0',
    [down('sm')]: {
      fontSize: 18,
      paddingLeft: 10,
      paddingRight: 10,
      margin: '15px 0',
    },
  },
  textModal: {
    fontSize: 15,
    fontWeight: 500,
    textAlign: 'center',
    paddingLeft: 20,
    paddingRight: 20,
    lineHeight: 1.4,
    [down('sm')]: {
      fontSize: 14,
      paddingLeft: 10,
      paddingRight: 10,
    },
  },
  textPhotoModal: {
    fontSize: 16,
    fontWeight: 500,
    lineHeight: 1.4,
    marginTop: 30,
    [down('sm')]: {
      fontSize: 15,
      paddingLeft: 10,
      paddingRight: 10,
    },
  },
  boxSlider: {
    width: '100%',
    margin: '0 auto',
    '& .slick-list': {
      width: '90%',
      position: 'relative',
      left: '5%',
    },
    '& .slick-slide': {},
    '& .slick-next:before, .slick-prev:before': {
      content: 'none',
      width: '60px!important',
      height: '60px!important',
      [down('sm')]: {
        width: '50px!important',
        height: '50px!important',
      },
    },
    '& .slick-next': {
      width: '60px!important',
      height: '60px!important',
      right: -15,
      [down('sm')]: {
        width: '50px!important',
        height: '50px!important',
      },
    },
    '& .slick-prev': {
      left: -15,
      width: '60px!important',
      height: '60px!important',
      [down('sm')]: {
        width: '50px!important',
        height: '50px!important',
      },
    },
  },
  mediaBottom: {
    position: 'absolute',
    bottom: 10,
    width: '100%',
    minWidth: 1100,
  },
  willChanges: {
    imageRendering: 'auto',
    willChange: 'transform',
    transform: 'translate3d(0, 0, 0)',
  },
}))
